import { api } from './api'
import { enabledStatus, userStatus } from './data'
import { createDialogProgress } from './dialog-progress'
import { md5 } from './md5'
import { dangerToast } from './toast'
import { translate } from './translation'
import { user } from './user'

export function serialize (obj: any, prefix: any): string {
    const str = []
    let p
    for (p in obj) {
        if (obj.hasOwnProperty(p)) {
            const k = prefix ? `${prefix}[${p}]` : p
            const v = obj[p]
            str.push(
                v !== null && typeof v === "object"
                    ? serialize(v, k)
                    : `${encodeURIComponent(k)}=${encodeURIComponent(v)}`,
            )
        }
    }
    return str.join("&")
}

export function pagination (
    page: number,
    perPage: number,
    total: number,
    display: number = 5,
) {
    const pages = Math.ceil(total / perPage)
    const out = []
    for (let p = 1; p <= pages; p++) {
        if (pages <= display) {
            out.push(p)
        } else {
            let prefix = Math.floor(display / 2)
            let suffix = Math.floor(display / 2)
            if (display % 2 === 0) {
                prefix--
            }
            if (page <= prefix) {
                suffix += prefix - page + 1
                prefix = page
            } else if (pages < page + suffix) {
                const diff = page + suffix - pages
                suffix -= diff
                prefix += diff
            }
            if (p === page || (p >= page - prefix && p <= page + suffix)) {
                out.push(p)
            }
        }
    }
    return out
}

export const enabledStatusRenderer = (value: any) => {
    const item = enabledStatus().find((o: any) => o.value === value)
    if (item) {
        return `<span class="text-${item.color}">${item.label}</span>`
    }
    return na()
}

export const userStatusRenderer = (value: any) => {
    const item = userStatus().find((o: any) => o.value === value)
    if (item) {
        return `<span class="text-${item.color}">${item.label}</span>`
    }
    return na()
}

export const na = () => {
    return `<span class="text-muted">N/A</span>`
}

export const byString = (o, s) => {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    var a = s.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];
        if (k in o) {
            o = o[k];
        } else {
            return;
        }
    }
    return o;
};

export function createImage (target: string, base64: string, override: boolean) {
    return new Promise((resolve, reject) => {
        api().track()
            .post("/images", {
                base64: base64,
                override,
                target: target ? md5(target) : null,
            })
            .then(({ data }) => {
                resolve(data);
            })
            .catch((error) => {
                reject(error);
            })
    })
}

export function mediaTarget (name) {
    return md5(name);
}

export function gcd (a, b) {
    if (b < 0.0000001) return a;
    return gcd(b, Math.floor(a % b));
}

export function fixRatio (fraction) {
    const len = fraction.toString().length - 2;
    let denominator = Math.pow(10, len);
    let numerator = fraction * denominator;

    const divisor = gcd(numerator, denominator);

    numerator /= divisor;
    denominator /= divisor;
    return Math.floor(denominator) / Math.floor(numerator);
}

export function chunk (array, size) {
    const chunked_arr = [];
    let index = 0;
    while (index < array.length) {
        chunked_arr.push(array.slice(index, size + index));
        index += size;
    }
    return chunked_arr;
}

export function slug (str) {
    str = String(str).toString()
    str = str.replace(/^\s+|\s+$/g, "") // trim
    str = str.toLowerCase()

    // remove accents, swap ñ for n, etc
    const swaps = {
        "0": ["°", "₀", "۰", "０"],
        "1": ["¹", "₁", "۱", "１"],
        "2": ["²", "₂", "۲", "２"],
        "3": ["³", "₃", "۳", "３"],
        "4": ["⁴", "₄", "۴", "٤", "４"],
        "5": ["⁵", "₅", "۵", "٥", "５"],
        "6": ["⁶", "₆", "۶", "٦", "６"],
        "7": ["⁷", "₇", "۷", "７"],
        "8": ["⁸", "₈", "۸", "８"],
        "9": ["⁹", "₉", "۹", "９"],
        a: [
            "à",
            "á",
            "ả",
            "ã",
            "ạ",
            "ă",
            "ắ",
            "ằ",
            "ẳ",
            "ẵ",
            "ặ",
            "â",
            "ấ",
            "ầ",
            "ẩ",
            "ẫ",
            "ậ",
            "ā",
            "ą",
            "å",
            "α",
            "ά",
            "ἀ",
            "ἁ",
            "ἂ",
            "ἃ",
            "ἄ",
            "ἅ",
            "ἆ",
            "ἇ",
            "ᾀ",
            "ᾁ",
            "ᾂ",
            "ᾃ",
            "ᾄ",
            "ᾅ",
            "ᾆ",
            "ᾇ",
            "ὰ",
            "ά",
            "ᾰ",
            "ᾱ",
            "ᾲ",
            "ᾳ",
            "ᾴ",
            "ᾶ",
            "ᾷ",
            "а",
            "أ",
            "အ",
            "ာ",
            "ါ",
            "ǻ",
            "ǎ",
            "ª",
            "ა",
            "अ",
            "ا",
            "ａ",
            "ä",
        ],
        b: ["б", "β", "ب", "ဗ", "ბ", "ｂ"],
        c: ["ç", "ć", "č", "ĉ", "ċ", "ｃ"],
        d: [
            "ď",
            "ð",
            "đ",
            "ƌ",
            "ȡ",
            "ɖ",
            "ɗ",
            "ᵭ",
            "ᶁ",
            "ᶑ",
            "д",
            "δ",
            "د",
            "ض",
            "ဍ",
            "ဒ",
            "დ",
            "ｄ",
        ],
        e: [
            "é",
            "è",
            "ẻ",
            "ẽ",
            "ẹ",
            "ê",
            "ế",
            "ề",
            "ể",
            "ễ",
            "ệ",
            "ë",
            "ē",
            "ę",
            "ě",
            "ĕ",
            "ė",
            "ε",
            "έ",
            "ἐ",
            "ἑ",
            "ἒ",
            "ἓ",
            "ἔ",
            "ἕ",
            "ὲ",
            "έ",
            "е",
            "ё",
            "э",
            "є",
            "ə",
            "ဧ",
            "ေ",
            "ဲ",
            "ე",
            "ए",
            "إ",
            "ئ",
            "ｅ",
        ],
        f: ["ф", "φ", "ف", "ƒ", "ფ", "ｆ"],
        g: ["ĝ", "ğ", "ġ", "ģ", "г", "ґ", "γ", "ဂ", "გ", "گ", "ｇ"],
        h: ["ĥ", "ħ", "η", "ή", "ح", "ه", "ဟ", "ှ", "ჰ", "ｈ"],
        i: [
            "í",
            "ì",
            "ỉ",
            "ĩ",
            "ị",
            "î",
            "ï",
            "ī",
            "ĭ",
            "į",
            "ı",
            "ι",
            "ί",
            "ϊ",
            "ΐ",
            "ἰ",
            "ἱ",
            "ἲ",
            "ἳ",
            "ἴ",
            "ἵ",
            "ἶ",
            "ἷ",
            "ὶ",
            "ί",
            "ῐ",
            "ῑ",
            "ῒ",
            "ΐ",
            "ῖ",
            "ῗ",
            "і",
            "ї",
            "и",
            "ဣ",
            "ိ",
            "ီ",
            "ည်",
            "ǐ",
            "ი",
            "इ",
            "ی",
            "ｉ",
        ],
        j: ["ĵ", "ј", "Ј", "ჯ", "ج", "ｊ"],
        k: ["ķ", "ĸ", "к", "κ", "Ķ", "ق", "ك", "က", "კ", "ქ", "ک", "ｋ"],
        l: ["ł", "ľ", "ĺ", "ļ", "ŀ", "л", "λ", "ل", "လ", "ლ", "ｌ"],
        m: ["м", "μ", "م", "မ", "მ", "ｍ"],
        n: ["ñ", "ń", "ň", "ņ", "ŉ", "ŋ", "ν", "н", "ن", "န", "ნ", "ｎ"],
        o: [
            "ó",
            "ò",
            "ỏ",
            "õ",
            "ọ",
            "ô",
            "ố",
            "ồ",
            "ổ",
            "ỗ",
            "ộ",
            "ơ",
            "ớ",
            "ờ",
            "ở",
            "ỡ",
            "ợ",
            "ø",
            "ō",
            "ő",
            "ŏ",
            "ο",
            "ὀ",
            "ὁ",
            "ὂ",
            "ὃ",
            "ὄ",
            "ὅ",
            "ὸ",
            "ό",
            "о",
            "و",
            "θ",
            "ို",
            "ǒ",
            "ǿ",
            "º",
            "ო",
            "ओ",
            "ｏ",
            "ö",
        ],
        p: ["п", "π", "ပ", "პ", "پ", "ｐ"],
        q: ["ყ", "ｑ"],
        r: ["ŕ", "ř", "ŗ", "р", "ρ", "ر", "რ", "ｒ"],
        s: ["ś", "š", "ş", "с", "σ", "ș", "ς", "س", "ص", "စ", "ſ", "ს", "ｓ"],
        t: ["ť", "ţ", "т", "τ", "ț", "ت", "ط", "ဋ", "တ", "ŧ", "თ", "ტ", "ｔ"],
        u: [
            "ú",
            "ù",
            "ủ",
            "ũ",
            "ụ",
            "ư",
            "ứ",
            "ừ",
            "ử",
            "ữ",
            "ự",
            "û",
            "ū",
            "ů",
            "ű",
            "ŭ",
            "ų",
            "µ",
            "у",
            "ဉ",
            "ု",
            "ူ",
            "ǔ",
            "ǖ",
            "ǘ",
            "ǚ",
            "ǜ",
            "უ",
            "उ",
            "ｕ",
            "ў",
            "ü",
        ],
        v: ["в", "ვ", "ϐ", "ｖ"],
        w: ["ŵ", "ω", "ώ", "ဝ", "ွ", "ｗ"],
        x: ["χ", "ξ", "ｘ"],
        y: [
            "ý",
            "ỳ",
            "ỷ",
            "ỹ",
            "ỵ",
            "ÿ",
            "ŷ",
            "й",
            "ы",
            "υ",
            "ϋ",
            "ύ",
            "ΰ",
            "ي",
            "ယ",
            "ｙ",
        ],
        z: ["ź", "ž", "ż", "з", "ζ", "ز", "ဇ", "ზ", "ｚ"],
        aa: ["ع", "आ", "آ"],
        ae: ["æ", "ǽ"],
        ai: ["ऐ"],
        ch: ["ч", "ჩ", "ჭ", "چ"],
        dj: ["ђ", "đ"],
        dz: ["џ", "ძ"],
        ei: ["ऍ"],
        gh: ["غ", "ღ"],
        ii: ["ई"],
        ij: ["ĳ"],
        kh: ["х", "خ", "ხ"],
        lj: ["љ"],
        nj: ["њ"],
        oe: ["ö", "œ", "ؤ"],
        oi: ["ऑ"],
        oii: ["ऒ"],
        ps: ["ψ"],
        sh: ["ш", "შ", "ش"],
        shch: ["щ"],
        ss: ["ß"],
        sx: ["ŝ"],
        th: ["þ", "ϑ", "ث", "ذ", "ظ"],
        ts: ["ц", "ც", "წ"],
        ue: ["ü"],
        uu: ["ऊ"],
        ya: ["я"],
        yu: ["ю"],
        zh: ["ж", "ჟ", "ژ"],
        "(c)": ["©"],
        A: [
            "Á",
            "À",
            "Ả",
            "Ã",
            "Ạ",
            "Ă",
            "Ắ",
            "Ằ",
            "Ẳ",
            "Ẵ",
            "Ặ",
            "Â",
            "Ấ",
            "Ầ",
            "Ẩ",
            "Ẫ",
            "Ậ",
            "Å",
            "Ā",
            "Ą",
            "Α",
            "Ά",
            "Ἀ",
            "Ἁ",
            "Ἂ",
            "Ἃ",
            "Ἄ",
            "Ἅ",
            "Ἆ",
            "Ἇ",
            "ᾈ",
            "ᾉ",
            "ᾊ",
            "ᾋ",
            "ᾌ",
            "ᾍ",
            "ᾎ",
            "ᾏ",
            "Ᾰ",
            "Ᾱ",
            "Ὰ",
            "Ά",
            "ᾼ",
            "А",
            "Ǻ",
            "Ǎ",
            "Ａ",
            "Ä",
        ],
        B: ["Б", "Β", "ब", "Ｂ"],
        C: ["Ç", "Ć", "Č", "Ĉ", "Ċ", "Ｃ"],
        D: ["Ď", "Ð", "Đ", "Ɖ", "Ɗ", "Ƌ", "ᴅ", "ᴆ", "Д", "Δ", "Ｄ"],
        E: [
            "É",
            "È",
            "Ẻ",
            "Ẽ",
            "Ẹ",
            "Ê",
            "Ế",
            "Ề",
            "Ể",
            "Ễ",
            "Ệ",
            "Ë",
            "Ē",
            "Ę",
            "Ě",
            "Ĕ",
            "Ė",
            "Ε",
            "Έ",
            "Ἐ",
            "Ἑ",
            "Ἒ",
            "Ἓ",
            "Ἔ",
            "Ἕ",
            "Έ",
            "Ὲ",
            "Е",
            "Ё",
            "Э",
            "Є",
            "Ə",
            "Ｅ",
        ],
        F: ["Ф", "Φ", "Ｆ"],
        G: ["Ğ", "Ġ", "Ģ", "Г", "Ґ", "Γ", "Ｇ"],
        H: ["Η", "Ή", "Ħ", "Ｈ"],
        I: [
            "Í",
            "Ì",
            "Ỉ",
            "Ĩ",
            "Ị",
            "Î",
            "Ï",
            "Ī",
            "Ĭ",
            "Į",
            "İ",
            "Ι",
            "Ί",
            "Ϊ",
            "Ἰ",
            "Ἱ",
            "Ἳ",
            "Ἴ",
            "Ἵ",
            "Ἶ",
            "Ἷ",
            "Ῐ",
            "Ῑ",
            "Ὶ",
            "Ί",
            "И",
            "І",
            "Ї",
            "Ǐ",
            "ϒ",
            "Ｉ",
        ],
        J: ["Ｊ"],
        K: ["К", "Κ", "Ｋ"],
        L: ["Ĺ", "Ł", "Л", "Λ", "Ļ", "Ľ", "Ŀ", "ल", "Ｌ"],
        M: ["М", "Μ", "Ｍ"],
        N: ["Ń", "Ñ", "Ň", "Ņ", "Ŋ", "Н", "Ν", "Ｎ"],
        O: [
            "Ó",
            "Ò",
            "Ỏ",
            "Õ",
            "Ọ",
            "Ô",
            "Ố",
            "Ồ",
            "Ổ",
            "Ỗ",
            "Ộ",
            "Ơ",
            "Ớ",
            "Ờ",
            "Ở",
            "Ỡ",
            "Ợ",
            "Ø",
            "Ō",
            "Ő",
            "Ŏ",
            "Ο",
            "Ό",
            "Ὀ",
            "Ὁ",
            "Ὂ",
            "Ὃ",
            "Ὄ",
            "Ὅ",
            "Ὸ",
            "Ό",
            "О",
            "Θ",
            "Ө",
            "Ǒ",
            "Ǿ",
            "Ｏ",
            "Ö",
        ],
        P: ["П", "Π", "Ｐ"],
        Q: ["Ｑ"],
        R: ["Ř", "Ŕ", "Р", "Ρ", "Ŗ", "Ｒ"],
        S: ["Ş", "Ŝ", "Ș", "Š", "Ś", "С", "Σ", "Ｓ"],
        T: ["Ť", "Ţ", "Ŧ", "Ț", "Т", "Τ", "Ｔ"],
        U: [
            "Ú",
            "Ù",
            "Ủ",
            "Ũ",
            "Ụ",
            "Ư",
            "Ứ",
            "Ừ",
            "Ử",
            "Ữ",
            "Ự",
            "Û",
            "Ū",
            "Ů",
            "Ű",
            "Ŭ",
            "Ų",
            "У",
            "Ǔ",
            "Ǖ",
            "Ǘ",
            "Ǚ",
            "Ǜ",
            "Ｕ",
            "Ў",
            "Ü",
        ],
        V: ["В", "Ｖ"],
        W: ["Ω", "Ώ", "Ŵ", "Ｗ"],
        X: ["Χ", "Ξ", "Ｘ"],
        Y: [
            "Ý",
            "Ỳ",
            "Ỷ",
            "Ỹ",
            "Ỵ",
            "Ÿ",
            "Ῠ",
            "Ῡ",
            "Ὺ",
            "Ύ",
            "Ы",
            "Й",
            "Υ",
            "Ϋ",
            "Ŷ",
            "Ｙ",
        ],
        Z: ["Ź", "Ž", "Ż", "З", "Ζ", "Ｚ"],
        AE: ["Æ", "Ǽ"],
        Ch: ["Ч"],
        Dj: ["Ђ"],
        Dz: ["Џ"],
        Gx: ["Ĝ"],
        Hx: ["Ĥ"],
        Ij: ["Ĳ"],
        Jx: ["Ĵ"],
        Kh: ["Х"],
        Lj: ["Љ"],
        Nj: ["Њ"],
        Oe: ["Œ"],
        Ps: ["Ψ"],
        Sh: ["Ш"],
        Shch: ["Щ"],
        Ss: ["ẞ"],
        Th: ["Þ"],
        Ts: ["Ц"],
        Ya: ["Я"],
        Yu: ["Ю"],
        Zh: ["Ж"],
    }

    Object.keys(swaps).forEach((swap) => {
        swaps[swap].forEach((s) => {
            str = str.replace(new RegExp(s, "g"), swap)
        })
    })
    return str
        .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
        .replace(/\s+/g, "-") // collapse whitespace and replace by -
        .replace(/-+/g, "-") // collapse dashes
        .replace(/^-+/, "") // trim - from start of text
        .replace(/-+$/, "")
}

export function fileExtension (file) {
    return file.name.split('.').pop().toLowerCase();
}

export function fileName (file) {
    return file.name.split('.').slice(0, -1).join('.');
}

export const allowedFilesExtensions = [
    'txt', ...pdfExt(), ...csvExt(), ...excelExt(), ...powerPointExt(), ...wordExt(), ...imageExt(),
];
const fileMaxPerChunk = 1024 * 1024 * 1.5;

export function saveFiles (folder, files, replaceFile: any = null): Promise<any> {
    const loader = createDialogProgress(`upload-files-into-${folder.id}`);
    loader.text = "Preparing...";
    return new Promise<void>(async (resolve, reject) => {
        const meta = [];
        // resolve meta and validation
        await Promise.all(Array.from(files).map(async (file, index) => {
            try {
                const data = await processFile(file);
                meta.push(data);
            } catch (e) {
                reject(e);
            }
        }));
        // resolve chunks and create file
        meta.forEach(async ({ name, extension, size, mimetype, file }) => {
            const steps = Math.ceil(size / fileMaxPerChunk);
            const step = Math.ceil(size / steps);
            let offset = 0;
            const fileData = [];
            await Promise.all([...new Array(steps).keys()].map(async (k) => {
                return new Promise<void>((res) => {
                    let endOffset = step + offset;
                    if (endOffset > size) {
                        endOffset = size;
                    }
                    const blob = file.slice(offset, endOffset);
                    offset += step;
                    const reader = new FileReader();
                    reader.onloadend = async () => {
                        fileData[k] = reader.result.toString();
                        res();
                    };
                    reader.readAsDataURL(blob);
                });
            }));

            // create File
            try {
                // create/update File Model
                let model: any;
                if (replaceFile) {
                    if (mimetype === replaceFile.mimetype) {
                        loader.text = `Updating File ${name} ...`;
                        model = await api().track().put(`/files/${replaceFile.id}`, {
                            id: replaceFile.id,
                            name: name,
                            extension: extension,
                            size: size,
                            mimetype: mimetype,
                        });
                    } else {
                        dangerToast({
                            text: translate('Replacement file should be :?', replaceFile.mimetype),
                        });
                        throw new Error(translate('Replacement file should be :?', replaceFile.mimetype));
                    }
                } else {
                    loader.text = `Creating File ${name} ...`;
                    model = await api().track().post('/files', {
                        name: name,
                        extension: extension,
                        size: size,
                        folder_id: folder.id,
                        path: `${folder.path},${folder.id}`,
                        mimetype: mimetype,
                    });
                }

                // Create File Data
                const sendChunk = async (index = 0) => {
                    if (index < fileData.length) {
                        loader.progress = {
                            value: index + 1,
                            total: fileData.length,
                        };
                        loader.text = `Uploading File ${name} (${loader.percentage}%) ...`;

                        await api().track().post('/files/data', {
                            file_id: model.data.id,
                            version: model.data.version,
                            raw_data: fileData[index],
                            position: index,
                        });
                        await sendChunk(index + 1);
                    }
                };
                await sendChunk();
                loader.dismiss();

                // done.
                resolve();
            } catch (e) {
                loader.dismiss();
                reject(e);
            }
        });
    });
}

export function processFile (file) {
    return new Promise((resolve, reject) => {
        const ext: string = fileExtension(file);
        if (!allowedFilesExtensions.includes(ext)) {
            reject(translate('File extension should be one of : :?', allowedFilesExtensions.join(', ')));
        } else {
            const fr = new FileReader();
            fr.onload = (event) => {
                const p = event.target.result.toString().split(";base64,");
                resolve({
                    name: fileName(file),
                    extension: ext,
                    size: file.size,
                    mimetype: p[0].replace(/(data:)|(;base64,)/g, ""),
                    data: event.target.result,
                    file,
                });
            };
            fr.readAsDataURL(file);
        }
    });
}

export function loadFile (file, version = null) {

    const loader = createDialogProgress(`file-${file.id}`);
    loader.text = "Starting Download...";

    if (version === null) {
        version = file.version;
    }
    return new Promise(async (resolve, reject) => {
        try {
            const chunksResponse: any = await api().track().get('/files/chunks?fileId=' + file.id + '&version=' + version);
            const positions = [...Array(parseInt(chunksResponse.data)).keys()];
            const chunks: any = [];

            const loadChunk = async (index = 0) => {
                if (index < positions.length) {
                    try {
                        loader.progress = {
                            value: index + 1,
                            total: positions.length,
                        };
                        loader.text = `Downloading (${loader.percentage}%) ...`;
                        const response: any = await api().get('/files/download?fileId=' + file.id + '&version=' + version + '&position=' + positions[index]);
                        chunks.push(atob(response.data));
                        await loadChunk(index + 1);
                    } catch (e) {
                        loader.dismiss();
                        reject(e);
                    }
                } else {
                    const blobFile = b64toBlob(chunks.join(), file.mimetype);
                    const url = URL.createObjectURL(blobFile);
                    loader.dismiss();
                    resolve(url);
                }
            };
            await loadChunk();
        } catch (e) {
            loader.dismiss();
            reject(e);
        }
    });
}

export function downloadFile (file, version = null) {
    loadFile(file, version).then((url: string) => {
        const a = document.createElement("a");
        a.href = url;
        a.download = `${file.name}.${file.extension}`;
        a.click();
    });
}

export function b64toBlob (b64Data, contentType = '', sliceSize = 512) {
    const byteCharacters = b64Data;
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice: any = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
}

export function copyText (text) {
    const node = document.createElement("textarea");
    node.value = text;
    node.select();
    node.setSelectionRange(0, 99999);
    document.execCommand("copy");
}

export function pdfExt () {
    return ['pdf'];
}

export function csvExt () {
    return ['csv'];
}

export function excelExt () {
    return [
        "xls",
        "xlt",
        "xlm",
        "xlsx",
        "xlsm",
        "xltx",
        "xltm",
        "xlsb",
        "xla",
        "xlam",
        "xll",
        "xlw",
    ];
}

export function powerPointExt () {
    return [
        "ppt",
        "pot",
        "pps",
        "pptx",
        "pptm",
        "potx",
        "potm",
        "ppam",
        "ppsx",
        "ppsm",
        "sldx",
        "sldm",
    ];
}

export function wordExt () {
    return [
        "doc",
        "dot",
        "wbk",
        "docx",
        "docm",
        "dotx",
        "dotm",
        "docb",
    ];
}

export function imageExt () {
    return [
        "png", "jpg", "jpeg", "gif", "tiff"
    ];
}

export const isPdf = (extension) => {
    return pdfExt().includes(extension);
};

export const isCsv = (extension) => {
    return csvExt().includes(extension);
};

export const isExcel = (extension) => {
    return excelExt().includes(extension);
};

export const isPowerPoint = (extension) => {
    return powerPointExt().includes(extension);
};

export const isWord = (extension) => {
    return wordExt().includes(extension);
};

export const isImage = (extension) => {
    return imageExt().includes(extension);
};

export function formatBytes (bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export function random (min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min);
}

export function createIds (prefix = 'gh') {
    const date = new Date();
    const time = date.getTime();
    return `${prefix}-${time}-${random(1987, time)}-${random(2009, time)}-${user().id.toString().padStart(12, '0')}-${random(2017, time)}`;
}

export function tableToExcel (fields, data, renderCallback = null) {
    const uri = 'data:application/vnd.ms-excel;base64,';
    const template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>';
    const base64 = function (s) {
        return window.btoa(unescape(encodeURIComponent(s)))
    };

    const format = function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
        })
    };

    const table = `
        <table>
            <thead>
                <tr>
                    ${fields.map(item => `<th style="background:#052274;color:white;">${item.title}</th>`).join('')}
                </tr>
            </thead>
            <tbody>
                ${data.map(row => `
                    <tr>
                        ${fields.map(item => `<td>${renderCallback(item.name, row[item.name]) ?? row[item.name]}</td>`).join('')}
                    </tr>
                `).join('')}
            </tbody>
        </table>
    `.replace((/  |\r\n|\n|\r/gm), "");

    var ctx = {
        worksheet: `Annual Fees Report ${(new Date()).getFullYear()}`,
        table: table,
    }


    var link = document.createElement("a");
    link.download = `annual-fees-report-${(new Date()).getFullYear()}.xls`;
    link.href = uri + base64(format(template, ctx));
    link.click();
}

export function flat2tree (flatList, idName = "id", parentIdName = "parent_id") {
    var map = {},
        node,
        roots = [],
        i

    for (i = 0; i < flatList.length; i += 1) {
        map[flatList[i][idName]] = i // initialize the map
        flatList[i].children = [] // initialize the children
    }

    for (i = 0; i < flatList.length; i += 1) {
        node = flatList[i]
        if (node[parentIdName] > 0) {
            if (map[node[parentIdName]] >= 0 && flatList[map[node[parentIdName]]]) {
                flatList[map[node[parentIdName]]].children.push(node)
            }
        } else {
            roots.push(node)
        }
    }
    return roots
}

export function treeToFlat (treeList, map = null, level = 0) {
    let out = [];
    treeList.forEach((item) => {
        if (map) {
            out.push(map(item, level));
        } else {
            out.push(item);
        }
        if (item.children && item.children.length > 0) {
            out = [...out, ...treeToFlat(item.children, map, level + 1)];
        }
    })
    return out;
}

export function uploadVideo (callback: (message: string, current: number, total: number) => void, file: File, size: number, maxPerChunk: number = 1024 * 1024) {
    return new Promise(async (resolve, reject) => {
        const id = createIds();
        const steps = Math.ceil(size / maxPerChunk);
        const step = Math.ceil(size / steps);
        let offset = 0;
        const fileData = [];
        let maxOffset = 0;
        await Promise.all([...new Array(steps).keys()].map(async (k) => {
            return new Promise((res) => {
                let endOffset = step + offset;
                if (endOffset > size) {
                    endOffset = size;
                }
                const blob = file.slice(offset, endOffset);
                offset += step;
                const reader = new FileReader();
                reader.onloadend = async () => {
                    fileData[k] = reader.result.toString();
                    if (maxOffset < endOffset) {
                        maxOffset = endOffset;
                        callback("Preparing...", endOffset, size);
                    }
                    res(null);
                };
                reader.readAsDataURL(blob);
            });
        }));

        const uploadChunk = (index = 0) => {
            callback("Uploading...", index, fileData.length);
            if (index < fileData.length) {
                api().post('/videos/chunks', {
                    id,
                    nb: index,
                    chunk: fileData[index],
                }).then(({ data }) => {
                    if (data) {
                        uploadChunk(index + 1);
                    } else {
                        uploadChunk(index);
                    }
                }).catch(error => reject);
            } else {
                api().post('/videos', {
                    id,
                    extension: 'mp4',
                }).then(({ data }) => {
                    resolve(data);
                }).catch(error => reject);
            }
        };

        uploadChunk();
    })
}

export function uploadFile (callback: (message: string, current: number, total: number) => void, file: File, size: number, maxPerChunk: number = 1024 * 1024) {
    return new Promise(async (resolve, reject) => {
        const id = createIds();
        const steps = Math.ceil(size / maxPerChunk);
        const step = Math.ceil(size / steps);
        let offset = 0;
        const fileData = [];
        let maxOffset = 0;
        await Promise.all([...new Array(steps).keys()].map(async (k) => {
            return new Promise((res) => {
                let endOffset = step + offset;
                if (endOffset > size) {
                    endOffset = size;
                }
                const blob = file.slice(offset, endOffset);
                offset += step;
                const reader = new FileReader();
                reader.onloadend = async () => {
                    fileData[k] = reader.result.toString();
                    if (maxOffset < endOffset) {
                        maxOffset = endOffset;
                        callback("Preparing...", endOffset, size);
                    }
                    res(null);
                };
                reader.readAsDataURL(blob);
            });
        }));

        const uploadChunk = (index = 0) => {
            callback("Uploading...", index, fileData.length);
            if (index < fileData.length) {
                api().post('/files/chunks', {
                    id,
                    nb: index,
                    chunk: fileData[index],
                }).then(({ data }) => {
                    if (data) {
                        uploadChunk(index + 1);
                    } else {
                        uploadChunk(index);
                    }
                }).catch(error => reject);
            } else {
                api().post('/files', {
                    id,
                    extension: file.name.split('.').pop(),
                }).then(({ data }) => {
                    resolve(data);
                }).catch(error => reject);
            }
        };

        uploadChunk();
    })
}

export function foldersSchemaList (data, callback = null) {
    const list = [];
    data.forEach(folder => {
        if (folder.children && folder.children.length > 0) {
            foldersSchemaList(folder.children, (f) => {
                const name = [];
                name.push(folder.name);
                name.push(f.name);
                list.push({
                    label: name.join('/'),
                    value: name.join('::'),
                });
            });
        } else {
            list.push({
                label: folder.name,
                value: folder.name,
            });
        }
        if (callback) {
            callback(folder);
        }
    })
    return list;
}
